import React, { Component } from 'react';
import './App.css';
import Router from "./core/Router/Router";
import {AppBar, Button, CircularProgress, Icon, IconButton, Toolbar, Typography} from "material-ui";
import Sidebar from './core/Sidebar/Sidebar';
import { withStyles } from 'material-ui/styles';
import { Link, withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import {UserActions} from "./actions/user.actions";
import {AuthenticateActions} from "./actions/authenticate.actions";
import AppSnackbar from "./shared/Snackbar/AppSnackbar";
import moment from 'moment';
import 'moment/locale/fr';
import ReactGA from 'react-ga';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        width: '100%',
        height: '100%',
        zIndex: 1,
        overflow: 'hidden',
    },
    appFrame: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '100%',
    },
    appBar: {
        position: 'fixed',
        marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    content: {
        backgroundColor: theme.palette.background.default,
        width: `calc(100% - ${theme.spacing.unit * 3 *2}px)`,
        padding: theme.spacing.unit * 3,
        maxWidth: '1180px',
        height: 'calc(100% - 56px)',
        margin: '56px auto',
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100% - 64px)',
            marginTop: 64,
            marginLeft: '296px'
        },
        [theme.breakpoints.down('md')]: {
            width: `calc(100% - ${theme.spacing.unit * 3 *2}px - 240px)`,
            marginLeft: '56px'
        },
        [theme.breakpoints.down('sm')]: {
            width: `calc(100% - ${theme.spacing.unit * 3 *2}px)`
        }
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    }
});

const ANALYTICS = process.env.NODE_ENV === 'development' ? 'UA-000000-1' : 'UA-48766092-7';

class App extends Component {

    state = {
        mobileOpen: false
    };

    componentDidMount(){
        // Set analytics
        ReactGA.initialize(ANALYTICS);
        moment.locale('fr'); // set to french
        this.props.dispatch(UserActions.fetchConnectedUser());
    }

    handleLogout = () => {
        return this.props.dispatch(AuthenticateActions.logout());
    };

    renderAuthenticationHeader = () => {
        const { fetchConnectedUser, user } = this.props;
        if(!fetchConnectedUser && user){
            return (
                <Button color="inherit" onClick={this.handleLogout}>Déconnexion</Button>
            )
        } else if(!fetchConnectedUser && !user){
            return (
                <Button color="inherit">
                    <Link to="/authenticate">Connexion</Link>
                </Button>
            )
        }
    };

    handleToggleDrawer = () => {
        this.setState({mobileOpen: !this.state.mobileOpen});
    };

    render() {
        const { classes, fetchConnectedUser } = this.props;
        return (
            <div className={classes.root}>
              <div className={classes.appFrame}>
                  <AppBar className={classes.appBar} position="fixed">
                      <Toolbar>
                          <IconButton
                              color="inherit"
                              aria-label="open drawer"
                              onClick={this.handleToggleDrawer}
                              className={classes.navIconHide}
                          >
                              <Icon>menu_icon</Icon>
                          </IconButton>
                          <Typography variant="title" color="inherit" style={{flex:1}}>
                              Slayers Online
                          </Typography>
                          <Button color="inherit">Accéder au site</Button>
                          {this.renderAuthenticationHeader()}
                      </Toolbar>
                  </AppBar>
                  <Sidebar
                      handleToggleDrawer={this.handleToggleDrawer}
                      {...this.state}
                  />
                  <AppSnackbar />
                  <main className={classes.content}>

                      {fetchConnectedUser &&
                          <div style={{textAlign: 'center'}}>
                              <CircularProgress />
                          </div>
                      }
                      {!fetchConnectedUser &&
                        <Router/>
                      }
                  </main>
              </div>
            </div>
        );
    }
}

function state2props(state){
    return {
        fetchConnectedUser: state.User.fetchConnectedUser,
        user: state.User.user
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(state2props)(App)));



// WEBPACK FOOTER //
// ./src/App.js